import { render, staticRenderFns } from "./MoneyIcon.vue?vue&type=template&id=c558491e&"
import script from "./MoneyIcon.vue?vue&type=script&lang=ts&"
export * from "./MoneyIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports